// Mock data for SET-G website - Images stored locally with high-quality versions from CDN
import logo from './assets/images/logo.webp';
import georgesKassi from './assets/images/georges-kassi.jpg';
import employeeFeminin from './assets/images/employee-feminin.webp';
import employeMasculin from './assets/images/employe-masculin.webp';
import enReunion from './assets/images/en-reunion.webp';
import formationsTelecom from './assets/images/formations-telecom.webp';
import formationsIT from './assets/images/formations-it.webp';
import conseilStrategique from './assets/images/conseil-strategique.webp';
import technicien from './assets/images/technicien.jpg';
import infrastructureSystemesReseaux from './assets/images/infrastructure-systemes-reseaux.jpg';
import formationsTechniques from './assets/images/formations-techniques.jpg';
import rollout from './assets/images/rollout.jpg';
import plateformeCollaborative from './assets/images/plateforme-collaborative.jpg';
import ingenierieRadio from './assets/images/ingenierie-radio.avif';
import dataCenterVirtualisation from './assets/images/data-center-virtualisation.jpg';
import auditBenchmarking from './assets/images/audit-benchmarking.jpg';

export const companyInfo = {
  name: "SET-G",
  fullName: "Strategies Engineerings and Technologies Global",
  legalStatus: "SARL - Société à Responsabilité Limitée",
  registreCommerce: "CI-ABJ-2020-B-07065",
  capital: "1.000.000 FCFA",
  tagline: "Excellence en ingénierie télécoms et technologies de l'information",
  slogan: "Une entreprise de référence dans l'industrie des nouvelles technologies de l'information",
  mission: "Fournir des solutions de haute qualité, afin d'accroître l'efficacité et la rentabilité de nos clients-partenaires",
  vision: "Être une entreprise de référence dans l'industrie des nouvelles technologies de l'information",
  ambition: "Contribuer à la digitalisation totale de la Côte d'Ivoire et de l'Afrique, en apportant de la valeur pour soutenir une croissance durable.",
  description: "Fournisseur de services télécoms et informatiques, concepteur de solutions technologiques avancées permettant aux entreprises d'accroître leur efficacité et leur profit, tout en améliorant la qualité de leurs services pour le bonheur des consommateurs.",
  values: ["Innovation", "Performance", "Simplicité", "Intégrité", "Partage", "Responsabilité"],
  rse: "SET-G s'engage à être une entreprise avant-gardiste de solutions vertes face aux défis environnementaux et sociétaux.",
  get experience() {
    const currentYear = new Date().getFullYear();
    const years = currentYear - parseInt(this.foundingYear);
    return `Plus de ${years} ans d'expérience`;
  },
  logo: logo,
  phones: ["+225 27 22 34 98 15", "+225 07 57 20 73 19"],
  phone: "+225 27 22 34 98 15",
  email: "contact@set-g.com",
  website: "www.set-g.com",
  address: "Angré Face Soleil 3, immeuble restaurant Wallace",
  postalBox: "06 BP 2179 Abidjan 06",
  country: "Côte d'Ivoire",
  hours: "Du lundi au vendredi de 08h à 17h",
  foundingYear: "2020"
};

export const services = {
  telecoms: {
    title: "Services Télécoms",
    description: "Expertise complète en ingénierie et optimisation des réseaux mobiles",
    image: employeMasculin,
    items: [
      "Ingénierie radio (planification, design et optimisation 2G/3G/4G)",
      "Audit et benchmarking QoS/QoE des réseaux mobiles",
      "Rollout et installation d'équipements télécoms",
      "Conception stratégique et tactique des réseaux",
      "Gestion de l'expérience client et amélioration QoS",
      "Mise en production et exploitation des réseaux"
    ]
  },
  informatique: {
    title: "Services Informatiques",
    description: "Solutions IT innovantes pour accroître votre efficacité",
    image: employeeFeminin,
    items: [
      "Plateformes collaboratives (architecture, implémentation)",
      "Data center et virtualisation",
      "Infrastructure systèmes et réseaux",
      "Conception d'architectures informatiques",
      "Solutions d'efficacité et de rentabilité",
      "Digitalisation des processus métier"
    ]
  },
  formations: {
    title: "Services Professionnels",
    description: "Formation et conseil pour développer vos compétences",
    image: enReunion,
    items: [
      "Formations techniques Télécoms (QoS, optimisation)",
      "Formations techniques Informatique (réseaux, sécurité, big data)",
      "Conseil en ingénierie des réseaux",
      "Optimisation des coûts et stratégie digitale",
      "Développement stratégique d'entreprise",
      "Recherche de partenariats et nouveaux revenus"
    ]
  }
};

export const serviceImages = {
  radioEngineering: ingenierieRadio,
  dataCenter: dataCenterVirtualisation,
  auditQos: auditBenchmarking,
  training: formationsTechniques,
  trainingTelecom: formationsTelecom,
  trainingIT: formationsIT,
  conseilStrategique: conseilStrategique,
  rollout: rollout,
  collaborative: plateformeCollaborative,
  infrastructure: infrastructureSystemesReseaux,
  technician: technicien,
  engineerMale: employeMasculin,
  heroEmployee: employeeFeminin,
  teamMeeting: enReunion
};

export const team = {
  leader: {
    name: "Georges KASSI",
    role: "Gérant & Fondateur",
    title: "MBA",
    photo: georgesKassi,
    qualifications: [
      "Master of Business Administration (MBA) - University of Cumbria, United Kingdom",
      "Diplôme d'Ingénieur Électronicien - INP-HB Yamoussoukro"
    ],
    experience: "Plus de 25 ans d'expérience dans l'industrie des télécoms",
    expertises: [
      "Planification et optimisation des réseaux radios",
      "Support techniques et opérationnels",
      "Budgétisations et réductions des coûts",
      "Gestion de la prestation des services",
      "Développement stratégique du business",
      "Marketing B2B",
      "Résolution des problèmes & Troubleshooting",
      "Team Building & Leadership"
    ],
    background: "Expert reconnu dans le secteur des télécommunications avec une expertise internationale acquise sur plusieurs continents. Spécialisé dans l'optimisation des réseaux mobiles et l'audit QoS, il a dirigé des projets d'envergure pour les plus grands opérateurs d'Afrique et du Moyen-Orient.",
    internationalExperience: "Kenya, Afrique du Sud, Nigeria, Algérie, Iran, Yémen, Ghana, Burkina Faso, Iraq, Bahreïn, Émirats Arabes Unis, Arabie Saoudite, Koweït, Oman, Liban"
  },
  description: "Une équipe dynamique, motivée et un personnel expérimenté, accompagnée d'une communauté d'experts-consultants et de sociétés partenaires."
};

// Calcul dynamique des années d'expérience
const currentYear = new Date().getFullYear();
const foundingYear = parseInt(companyInfo.foundingYear);
const yearsOfExperience = currentYear - foundingYear;

export const stats = {
  experience: `${yearsOfExperience}+`,
  projects: "14+",
  clients: "5+",
  leaderExperience: "25+",
  localites: "255+"
};

export const projects = [
  { id: 1, title: "PNCR - Connectivité Rurale", client: "ARTCI", description: "Contrôle de la couverture radioélectrique Orange CI.", status: "Terminé", year: "2026", category: "Contrôle Réseau", localites: "74 localités" },
  { id: 2, title: "Audit QoS 2025 S2", client: "ARTCI", description: "Audit QoS réseaux mobiles 2025.", status: "Terminé", year: "2025", category: "Audit QoS", localites: "97 localités" },
  { id: 3, title: "Audit QoS 2025 S1", client: "ARTCI", description: "Campagne d'audit QoS premier semestre 2025.", status: "Terminé", year: "2025", category: "Audit QoS", localites: "80 localités" },
  { id: 4, title: "Digitalisation des Rondes SIR", client: "SIR", description: "AMOA pour la digitalisation des rondes des opérateurs.", status: "Terminé", year: "2024", category: "Digitalisation" },
  { id: 5, title: "Audit QoS 2024 S2", client: "ARTCI", description: "Audit QoS deuxième semestre 2024.", status: "Terminé", year: "2024", category: "Audit QoS" },
  { id: 6, title: "Audit QoS 2024 S1", client: "ARTCI", description: "Audit QoS premier semestre 2024.", status: "Terminé", year: "2024", category: "Audit QoS" },
  { id: 7, title: "Audit QoS 2023", client: "ARTCI", description: "Campagne d'audit QoS année 2023.", status: "Terminé", year: "2023", category: "Audit QoS" },
  { id: 8, title: "Audit Comparatif QoS - POC", client: "MOOV AFRICA CI", description: "Audit comparatif Proof of Concept.", status: "Terminé", year: "2022", category: "Audit QoS" },
  { id: 9, title: "Contrôles Inopinés QoS 2021", client: "EDAHTECH", description: "Organisation du congrès UPU.", status: "Terminé", year: "2021", category: "Contrôle Réseau" },
  { id: 10, title: "Audit QoS 2020", client: "EDAHTECH", description: "Collecte et reporting campagne d'audit.", status: "Terminé", year: "2020", category: "Audit QoS" }
];
